import axios, { AxiosRequestConfig } from 'axios';
import { ResponseCSOSHeaders } from '..';
import {
  compose as lcompose,
  filter as lfilter,
  negate as lnegate,
  eq as leq,
  prop as lprop,
} from 'lodash/fp';

const getOpenApiConfig = (): AxiosRequestConfig => ({
  withCredentials: `${import.meta.env.VITE_WITHCREDENTIALS}` === 'true',
});

const getApiConfig = (hR: ResponseCSOSHeaders): AxiosRequestConfig => ({
  withCredentials: `${import.meta.env.VITE_WITHCREDENTIALS}` === 'true',
  headers: {
    'Content-type': 'application/json',
    'x-csrf-csos-token': `${hR['x-csrf-csos-token']}`,
    authorization: `${hR.authorization}`,
  },
});

export const csosApi = (baseURL: string) =>
  lcompose(
    axios.create,
    a => ({
      ...a,
      baseURL,
    }),
    getApiConfig
  );

export const csosUpmApi = lcompose(
  axios.create,
  a => ({
    ...a,
    baseURL: `${import.meta.env.VITE_API_USER_PROFILE_MGMT_URL}`,
  }),
  getApiConfig
);

export const csosUserLifecycleApi = (headers: ResponseCSOSHeaders) => {
  const instance = csosApi(`${import.meta.env.VITE_API_USER_LIFECYCLE_URL || ''}`)(headers);

  return {
    /**
     * Toggles a user's lifecycle state (suspend or unsuspend)
     * POST /v1/api/okta/users/lifecycle/{action}/{userId}
     */
    toggleUserLifecycle: (action: 'suspend' | 'unsuspend' | 'reset-password' | 'unlock' | 'activate', userId: string) => {
      const cleanUserId = encodeURIComponent(userId.trim());
      // No request body required as per specification
      return instance.post(`/v1/api/okta/users/lifecycle/${action}/${cleanUserId}`);
    }
  };
};

export const csosUserOktaSearchApi = (headers: ResponseCSOSHeaders, userEmail: string) => {
  // const instance = csosApi(`https://csos-okta-management-dev.deacsos.gov`)(headers);
  const instance = csosApi(`${import.meta.env.VITE_API_USER_LIFECYCLE_URL || ''}`)(headers);
  /**
   * Search user's lifecycle okta state
   * GET /v1/api/okta/users/lifecycle/{action}/{userId}
   */
  const cleanUserEmail = userEmail.trim();
  // const cleanUserEmail = encodeURIComponent(userEmail.trim());
  // No request body required as per specification
  return instance.get(`/v1/api/okta/usersInfo/${cleanUserEmail}`);

};


export const csosAccountActivationApi = lcompose(
  axios.create,
  a => ({
    ...a,
    baseURL: `${import.meta.env.VITE_API_ACCOUNT_ACTIVATION_URL}`,
  }),
  getApiConfig
);

export const csosApproverApi = lcompose(
  axios.create,
  a => ({
    ...a,
    baseURL: `${import.meta.env.VITE_API_APPROVER_URL}`,
  }),
  getApiConfig
);

export const csosRequestMgmtApi = lcompose(
  axios.create,
  a => ({
    ...a,
    baseURL: `${import.meta.env.VITE_API_REQUEST_MGMT_URL}`,
  }),
  getApiConfig
);

export const csosEnrollmentApi = lcompose(
  axios.create,
  a => ({
    ...a,
    baseURL: `${import.meta.env.VITE_API_ENROLLMENT_URL}`,
  }),
  getApiConfig
);

export const csosTokenGenApi = lcompose(
  axios.create,
  a => ({ ...a, baseURL: `${import.meta.env.VITE_API_TOKEN_GEN_URL}` }),
  getOpenApiConfig
);

export const csosIcamServiceApi = lcompose(
  axios.create,
  a => ({ ...a, baseURL: `${import.meta.env.VITE_API_ICAM_SERVICE_URL}` }),
  getOpenApiConfig
);

export const csosOktaApi = lcompose(axios.create, () => ({
  baseURL: `${import.meta.env.VITE_OKTA_ORG_URL}`,
}));

export type IApiCallStatus = undefined | null | true | false;

export const deleteApiCallStatus = ({ type }: { type: string }) =>
  lfilter(lcompose(lnegate(leq(type)), lprop('type')));
